import type {
  VendorRecord,
  CreateVendorRequest,
  CreateVendorResponse,
  DeleteVendorResponse,
  DiscoverVendorModelsResponse,
  ListVendorDiscoveredModelsResponse,
  ListVendorsResponse,
  SetVendorOfficialKeyRequest,
  UpdateVendorRequest,
  UpdateVendorResponse,
  VendorOfficialKeyResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listVendors(
  fetchImpl: typeof fetch = fetch,
): Promise<ListVendorsResponse> {
  return opsApiRequest<ListVendorsResponse>('/v1/ops/vendors', { method: 'GET' }, fetchImpl);
}

export function createVendor(
  body: CreateVendorRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<CreateVendorResponse> {
  return opsApiRequest<CreateVendorResponse>('/v1/ops/vendors', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
  }, fetchImpl);
}

export function updateVendor(
  slug: string,
  body: UpdateVendorRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<UpdateVendorResponse> {
  return opsApiRequest<UpdateVendorResponse>(`/v1/ops/vendors/${slug}`, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body,
  }, fetchImpl);
}

export function deleteVendor(
  slug: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DeleteVendorResponse> {
  return opsApiRequest<DeleteVendorResponse>(`/v1/ops/vendors/${slug}`, {
    method: 'DELETE',
  }, fetchImpl);
}

export function getVendorOfficialKey(
  slug: string,
  fetchImpl: typeof fetch = fetch,
): Promise<VendorOfficialKeyResponse> {
  return opsApiRequest<VendorOfficialKeyResponse>(
    `/v1/ops/vendors/${encodeURIComponent(slug)}/official-key`,
    { method: 'GET' },
    fetchImpl,
  );
}

export function setVendorOfficialKey(
  slug: string,
  body: SetVendorOfficialKeyRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<VendorOfficialKeyResponse> {
  return opsApiRequest<VendorOfficialKeyResponse>(
    `/v1/ops/vendors/${encodeURIComponent(slug)}/official-key`,
    { method: 'PUT', body },
    fetchImpl,
  );
}

export function discoverVendorModels(
  slug: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DiscoverVendorModelsResponse> {
  return opsApiRequest<DiscoverVendorModelsResponse>(
    `/v1/ops/vendors/${encodeURIComponent(slug)}/discover-models`,
    { method: 'POST', body: {} },
    fetchImpl,
  );
}

export function listVendorDiscoveredModels(
  slug: string,
  fetchImpl: typeof fetch = fetch,
): Promise<ListVendorDiscoveredModelsResponse> {
  return opsApiRequest<ListVendorDiscoveredModelsResponse>(
    `/v1/ops/vendors/${encodeURIComponent(slug)}/discovered-models`,
    { method: 'GET' },
    fetchImpl,
  );
}
